export default __webpack_public_path__ + "static/media/mirakl.5a3dbf66.svg";